import { render, staticRenderFns } from "./CentralEventos.vue?vue&type=template&id=f1c20a10&scoped=true&lang=pug"
import script from "./CentralEventos.vue?vue&type=script&lang=js"
export * from "./CentralEventos.vue?vue&type=script&lang=js"
import style0 from "./CentralEventos.vue?vue&type=style&index=0&id=f1c20a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c20a10",
  null
  
)

export default component.exports